export default {
  title: 'Imagem de Regra de Preço Inteligente',
  select: {
    generate_title: 'Gerar uma imagem com IA',
    generate_subtitle: 'Iremos criar uma com base na sua regra de preço inteligente.',
    generate_cta: 'Gerar',
    upload_link: 'ou carregue do seu dispositivo',
    rate_limit_company: {
      title: 'Precisamos de um momento',
      description: 'O seu restaurante gerou muitas imagens esta hora. Tente novamente em {{time}}.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'A recuperar o fôlego',
      description: 'Parece que tentou esta regra várias vezes seguidas. Estaremos prontos novamente em {{time}}.',
    },
  },
  generating: {
    title: 'A gerar a sua imagem…',
    progress: {
      cooking: 'A preparar algo saboroso…',
      plating: 'A empratar…',
      finishing: 'A dar os últimos retoques…',
    },
  },
  preview: {
    alt: 'Imagem de regra de preço inteligente gerada',
    hint: 'Não ficou bem? Regenere ou continue para recortar a imagem.',
    click_to_expand: 'Clique para expandir',
    regenerate: 'Regenerar',
    continue: 'Continuar para editar',
  },
  toasts: {
    upload_success: 'Imagem carregada com sucesso.',
    upload_failed: 'Falha ao carregar imagem.',
    delete_success: 'Imagem eliminada com sucesso.',
    delete_failed: 'Falha ao eliminar imagem.',
    generate_success: 'Imagem gerada com sucesso.',
    generate_failed: 'Falha ao iniciar a geração de imagem.',
    generate_timeout: 'A imagem ainda está a ser gerada. Aparecerá aqui quando estiver pronta.',
    rate_limit_company: 'Limite de imagens por hora atingido para este restaurante. Tente novamente em {{time}}.',
    rate_limit_smart_pricing_rule: 'Demasiadas tentativas para esta regra agora — tente novamente em {{time}}.',
  },
  time: {
    seconds_one: '1 segundo',
    seconds_other: '{{count}} segundos',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minutos',
    hours_one: '1 hora',
    hours_other: '{{count}} horas',
  },
};
